<template>
    <div>
        <container :active_path="path" :plate="'云项目'">
            <div class="base-warp" v-loading="fullloading">
                <div class="head">
                    <div class="title">
                        <el-form :model="form" label-width="80px" :inline="true" size="mini">
                            <el-form-item label="来源">
                                <el-select v-model="form.source" value-key="name" placeholder="请选择客户来源" clearable filterable allow-create>
                                    <el-option v-for="(item, index) in sources"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="客户姓名">
                                <el-input v-model="form.username" placeholder="请填写客户姓名" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="客户手机">
                                <el-input v-model="form.telephone" placeholder="请填写客户手机" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="客户等级">
                                <el-select v-model="form.level" value-key="name" placeholder="请选择客户等级" clearable filterable>
                                    <el-option label="A" value="A"></el-option>
                                    <el-option label="B" value="B"></el-option>
                                    <el-option label="C" value="C"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="添加时间">
                                <el-date-picker
                                    v-model="form.adddate"
                                    class="custom-datepicker"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="分配时间">
                                <el-date-picker
                                    v-model="form.designatedate"
                                    class="custom-datepicker"
                                    type="daterange"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="导师">
                                <el-input v-model="form.tutorname" placeholder="请填写导师姓名" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="confirm" icon="el-icon-search">搜索</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="success" @click="toadd" icon="el-icon-plus">添加客户</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="danger" @click="exportBtn" icon="el-icon-download">导出客户数据</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12" :offset="0"></el-col>
                        <el-col :span="12" :offset="0"></el-col>
                    </el-row>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    size="mini"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="来源"  align="center" width="140">
                            <template slot-scope="s">
                                <p class="text" v-if="s.row.type=='client'">{{s.row.source}}</p>
                                <p class="text" v-if="s.row.type=='invest'">真会投资/我要买房</p>
                                <p class="text" v-if="s.row.type=='project'">真会投资/关注楼盘</p>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名"  align="center" width="100" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="telephone" label="客户手机"  align="center" width="100"></el-table-column>
                        <!-- <el-table-column prop="projectname" label="意向楼盘" show-overflow-tooltip></el-table-column> -->
                        <el-table-column prop="level" label="客户等级"  align="center" ></el-table-column>
                        <el-table-column prop="ctime" label="添加时间"  align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="adduser" label="添加人"  align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column label="分配时间" show-overflow-tooltip>
                            <template slot-scope="s">
                                <p v-if="s.row.designate">
                                    <span class="text">{{s.row.designatetime}}</span>
                                </p>
                                <p class="text text-danger" v-else>待分配</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="分配导师" prop="tutorname" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="ftime" label="上次跟进"  align="center" width="140" show-overflow-tooltip>
                            <template slot-scope="s">
                                <span class="text">{{s.row.ftime}}</span>
                                <span class="text time-text">{{s.row.ctype}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="s">
                                <el-button type="primary" size="mini" @click="edit(s.row)" plain>查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>
        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from '../../../components/container.vue'
import XLSX from 'xlsx';
export default {
    components: { container },
    data() {
        return {
            path: '/project/collect',
            form: {
                telephone: '',
                username: '',
                source: '',
                level: '',
                adddate: [],
                designatedate: [],
                tutorname: '',
            },
            tableData: [],
            loading: false,
            pageNo: 1,
            pagesize: 15,
            total: 0,
            statusArr: [
                {
                    label: '全部',
                    value: '',
                },
                {
                    label: '有效',
                    value: true,
                },
                {
                    label: '无效',
                    value: false,
                },
            ],
            typesBtnObj: {
                price_change: 'info',
                opening: 'info',
                discounts: 'warning',
                consult: 'danger',
                dynamic: 'success',
            },
            sources: [
                {name: '真会投资/微信'},
                {name: '公众号/浩哥看市'},
                {name: '公众号/浩哥观商业'},
                {name: '公众号/真会投资'},
                {name: '新媒/抖音'},
                {name: '公众号/黄峰淘房'},
                {name: '视频号/胡二筒'},
                {name: '公众号/张涛地产观'},
                {name: '公众号/阿松评楼'},
                {name: '公众号/老欢咵房'},
                {name: '公众号/马哥说房'},
                {name: '合作/壹楼'},
                {name: '合作/亿房'},
                {name: '合作/嘟嘟租房'},
                {name: '合作/其他'},
            ],
            fullloading: false,
        }
    },
    mounted () {
        this.getTableData();
    },
    methods: {
        workbook2blob (workbook) {
            // 生成excel的配置项
            var wopts = {
                // 要生成的文件类型
                bookType: 'xlsx',
                // // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
                bookSST: false,
                type: 'binary'
            }
            var wbout = XLSX.write(workbook, wopts)
            // 将字符串转ArrayBuffer
            function s2ab (s) {
                var buf = new ArrayBuffer(s.length)
                var view = new Uint8Array(buf)
                for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
                return buf
            }
            let buf = s2ab(wbout)
            var blob = new Blob([buf], {
                type: 'application/octet-stream'
            })
            return blob
        },
            // 将blob对象 创建bloburl,然后用a标签实现弹出下载框
        openDownloadDialog (blob, fileName) {
            if (typeof blob === 'object' && blob instanceof Blob) {
                blob = URL.createObjectURL(blob) // 创建blob地址
            }
            var aLink = document.createElement('a')
            aLink.href = blob
            // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，有时候 file:///模式下不会生效
            aLink.download = fileName || ''
            var event
            if (window.MouseEvent) event = new MouseEvent('click')
            //   移动端
            else {
                event = document.createEvent('MouseEvents')
                event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            }
            aLink.dispatchEvent(event)
        },
        exportBtn () {
            this.fullloading = true;
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                telephone: this.form.telephone,
                username: this.form.username,
                source: this.form.source,
                level: this.form.level,
                adddate: JSON.stringify(this.form.adddate),
                designatedate: JSON.stringify(this.form.designatedate),
                tutorname: this.form.tutorname,
            }
            this.$api.getallclientswithoutpage(params).then(
                data=>{
                    var columns = [], column = {};
                    for(let client of data){
                        column = {
                            '来源': client.source,
                            '姓名': client.name,
                            '客户手机': client.telephone,
                            '客户等级': client.level,
                            '添加时间': client.addDate,
                            '添加人': client.adduser,
                            '分配时间': client.designatetime,
                            '分配导师': client.tutorname,
                            '上次跟进': client.ftime,
                            '跟进类型': client.ctype,
                            '标签': client.tags,
                            '首付预算': client.downpayment,
                            '总预算': client.totalpayment,
                            '备注': client.remark,
                        }
                        columns.push(column);
                    }
                    this.exportExcel(columns)
                    this.fullloading = false;
                }
            )
        },
        exportExcel (columns) {

            let sheet1data = columns;
            var sheet1 = XLSX.utils.json_to_sheet(sheet1data)
            console.log(sheet1, 'sheet123')
            // 创建一个新的空的workbook
            var wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, sheet1, '客户数据')
            const workbookBlob = this.workbook2blob(wb)
            this.openDownloadDialog(workbookBlob, '真会投资客户数据.xlsx')
        },
        toadd() {
            this.$router.push({path: '/project/collect/add'})
        },
        edit(row) {
            this.$router.push({path: '/project/collect/follow', query:{id: row._id['$oid']}})
        },
        getTableData() {
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                telephone: this.form.telephone,
                username: this.form.username,
                source: this.form.source,
                level: this.form.level,
                adddate: JSON.stringify(this.form.adddate),
                designatedate: JSON.stringify(this.form.designatedate),
                tutorname: this.form.tutorname,
            }
            this.$api.getProjectCollectList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        confirm() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        querySearchAsync(queryString, cb) {
            if (this.loading) return;
            var params = {
                name: queryString||'',
                region: '',
                price: '',
                pageNo: 1,
                pagesize: 5,
            }
            this.loading = true;
            this.$api.getProjectList(params).then(
                data=>{
                    this.loading = false;
                    let {list} = data;
                    cb(list);
                }
            )
        },
        handleSelect(item) {
            this.form.projectid = item._id['$oid'];
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path == "/project/collect/follow"){
            this.getTableData();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.table-box{
    margin-top: 10px;
}
.tags{
    .tags-btn{
        margin-left: 4px;
        padding: 0 4px;
        line-height: 26px;
    }
}
.time-text{
    color: #3a8ee6;
}
.custom-datepicker{
    width: 240px;
}
</style>